import styled from '@emotion/styled';
import {AppBar} from '@mui/material';
export const StyledAppBar=styled(AppBar)({
    width: { sm: `calc(100%-500px)` },
    background:'var(--black)',color:'var(--white)'
})